// The four mapping directions, in one place.
//
// `batchType` used to be a bare literal in ~15 spots here (and ~10 in scrape-matcher-back,
// ~14 in ia-normalizer), which is why adding a direction means auditing three repos. This
// module does not remove the literals from readable comparisons — it exists so the places
// where a MISSING value is a bug have a single source: toggles, chip maps, validators.
//
// Adding a direction: add it here, then grep for ALL_BATCH_TYPES.

export const SKU2RAW = 'sku2raw'   // SKU → competitor/own products
export const RAW2SKU = 'raw2sku'   // raw product → SKU catalog
export const RAW2RAW = 'raw2raw'   // own product → competitor products
export const WAR2WAR = 'war2war'   // competitor product → own catalog (inverse of raw2raw)

export const ALL_BATCH_TYPES = [SKU2RAW, RAW2SKU, RAW2RAW, WAR2WAR]

// Product ↔ product directions: they share PRODUCTS_TO_BE_MATCHED and its UI.
export const PRODUCT_MATCH_TYPES = [RAW2RAW, WAR2WAR]

// Directions the drawer must ask a customer for.
export const CUSTOMER_REQUIRED_TYPES = [SKU2RAW, RAW2RAW, WAR2WAR]

export const BATCH_TYPE_LABELS = {
    [SKU2RAW]: 'SKU to Product',
    [RAW2SKU]: 'Product to SKU',
    [RAW2RAW]: 'Product to Product',
    [WAR2WAR]: 'Competitor to Own',
}

export const BATCH_TYPE_COLORS = {
    [SKU2RAW]: 'primary',
    [RAW2SKU]: 'secondary',
    [RAW2RAW]: 'info',
    [WAR2WAR]: 'warning',
}
